import React from 'react';
import classnames from 'classnames';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import { PrevArrow, NextArrow } from './arrows';
import './styles.mod.scss';

export default class Carousel extends React.Component {
  componentDidMount() {
    this.resize();
  }

  componentDidUpdate(prevProps) {
    const prevKeys = (prevProps.children || []).map(c => c.key);
    const keys = (this.props.children || []).map(c => c.key);
    if (keys.join() !== prevKeys.join()) {
      this.reset();
      this.resize();
    }
  }

  resize() {
    /* https://github.com/akiran/react-slick/issues/809 */
    /* https://github.com/akiran/react-slick/issues/254 */
    if (
      this.slick.innerSlider &&
      typeof this.slick.innerSlider.onWindowResized === 'function'
    ) {
      this.slick.innerSlider.onWindowResized();
    }
  }

  reset() {
    if (this.slick && typeof this.slick.slickGoTo === 'function') {
      this.slick.slickGoTo(0);
    }
  }

  render() {
    const {
      dots,
      lazyLoad,
      slidesToShow,
      slidesToScroll,
      responsive,
      arrows,
      autoplay,
      infinite,
      prevArrow,
      nextArrow,
      className,
      children
    } = this.props;

    const settings = {
      speed: 500,
      swipe: false,
      dots,
      infinite,
      lazyLoad,
      autoplay,
      slidesToShow,
      slidesToScroll,
      responsive,
      arrows,
      prevArrow: prevArrow || <PrevArrow />,
      nextArrow: nextArrow || <NextArrow />,
      className: classnames('carousel', className)
    };

    return (
      <Slider {...settings} ref={div => (this.slick = div)}>
        {children}
      </Slider>
    );
  }
}

Carousel.defaultProps = {
  dots: false,
  infinite: false,
  lazyLoad: true,
  autoplay: false,
  arrows: true,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 2 } }
  ]
};
